import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES } from "./locales";

// Topbar ve login için kompakt dil seçici. Yerel <select> kullanır:
// erişilebilir, RTL uyumlu ve ekstra dropdown state'i gerektirmez.
export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation("common");
  const current = i18n.resolvedLanguage ?? "tr";

  return (
    <label className={`lang-switcher${className ? ` ${className}` : ""}`}>
      <span className="sr-only">{t("shell.language")}</span>
      <select
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        aria-label={t("shell.language")}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.nativeName}
          </option>
        ))}
      </select>
    </label>
  );
}
